import React from 'react';

export enum DisplayTypes {
  ErrorButton = 'error-button',
}

export type Option = {
  value: string;
  label: string;
  description?: string;
  // matched by search but never rendered — synonyms, former names
  searchTerms?: string;
  start?: React.ReactNode;
  hasBottomSeparator?: boolean;
  children?: Option[];
  selectChildrenOnly?: boolean;
  displayType?: DisplayTypes;
};

export { Size } from 'shared/components/ui/form-select-trigger/types';
